<!-- eslint-disable -->
<template>
  <div id="onlinestate">
    <div class="row align-items-start pb-2">      
      <div class="col-2">
        <button
          type="button"
          @click.prevent="onButtonOnlineClick"
          class="btn btn-outline-primary"
        >
        Aktuellen Status anzeigen
        </button>
      </div>
      <div class="col-10"></div>         
    </div>

    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '340px' }"
          :data-items="filteredData"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          @filterchange="filterChange"
          @sortchange="sortChange"
          :filter-cell-render="filterRender"
          @custom="customHandler"
        >
          <template v-slot:myTemplate="{ props }">
            <cell-container :data-item="props.dataItem" />
          </template>
          <template v-slot:filterSlotTemplate="{ props, methods }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 120px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
        </Grid>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import CellContainer from "@/components/ControlCenter/CellContainer";
import { AreaStore } from "@/store/modules/areastore"
import { UserStore } from "@/store/modules/userstore"
 
export default {
  name: "DeviceAlarmState",
  inheritAttrs: false,
  props: ["MonitoringName"],
  components: {
    Grid,
    CellContainer,
  },
  data: function () {
    return {
      filter: {},
      sort: [
        { field: "nameBereich", dir: "asc" },
        { field: "hinweis", dir: "asc" },
        { field: "nameGeraet", dir: "asc" },
      ],
      filteredData: [],
      originData: [],
      staticColumns: [ 
        { field: 'idMandant', title: 'IdMandant', filterable: false, hidden: true },
        { field: 'fkBereich', title: 'fkBereich', filterable: false, hidden: true },
        { field: 'fkGeraet', title: 'fkGeraet', filterable: false, hidden: true },
        { field: 'fkGeraetTyp', title: 'fkGeraetTyp', filterable: false, hidden: true },
        { field: 'nameKommKanal', title: 'KomKanla-Quelle', filterCell: 'filterSlotTemplate', width:'200px' , filterable: false, hidden: true },
        { field: 'auswerteStatus', title: 'Status', filterCell: 'filterSlotTemplate', width:'50px' , cell: "myTemplate", filterable: false },
        { field: 'nameBereich', title: 'Bereich', width: '180px' ,filterCell: 'filterSlotTemplate', },
        { field: 'hinweis', title: 'Hinweis', filterCell: 'filterSlotTemplate', width:'200px' },
        { field: 'nameGeraet', title: 'NameGeraet', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'telNrGeraet', title: 'TelNrGeraet', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'telNrGeraetZusatz', title: 'TelNrGeraetZusatz', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},
        { field: 'sendung', title: 'Sendung', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'gesendetDatumZeit', title: 'Gesendet am', filterCell: 'filterSlotTemplate', width:'170px' ,filterable: false },
        { field: 'quelle', title: 'Sendungs-Quelle', filterCell: 'filterSlotTemplate', width:'120px' , filterable: false },
        { field: 'empfangSendung', title: 'Empfang-Sendung', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'empfangDatumZeit', title: 'Empfang am', filterCell: 'filterSlotTemplate', width:'170px' ,filterable: false },
        { field: 'empfangQuelle', title: 'Empfang-Quelle', filterCell: 'filterSlotTemplate', width:'120px' , filterable: false },       
        { field: 'sender', title: 'Sender', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},
        { field: 'empfangSender', title: 'EmpfangSender', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true },
        { field: 'deviceId', title: 'DeviceId', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},        
        { field: 'imeiNr', title: 'ImeiNr', filterCell: 'filterSlotTemplate', width:'300px' ,filterable: false, hidden: true},
        { field: 'message', title: 'Message', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},
        { field: 'isTest', title: 'IsTest', width:'50px' , filterable: false, hidden: true},
        { field: 'isClosed', title: 'IsClosed', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},
        { field: 'isError', title: 'IsError', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},
        { field: 'isTimeout', title: 'IsTimeout', width:'50px' , filterable: false, hidden: true},
        { field: 'createdAt', title: 'CreatedAt', filterCell: 'filterSlotTemplate', width:'300px' , filterable: false, hidden: true},
        
        ],
    };
  },
  computed: {
    columns() {
      return [...this.staticColumns];
    },
  },
  methods: {
    onButtonOnlineClick() {
      this.getData();
    },
    onButtonOnlineRefresh() {
      this.refreshData();
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },
    getAreas() {
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      const areas = [];
      for (let i = 0; i < areaInfo.areas.length; i++) {
        areas.push(areaInfo.areas[i]["idBereich"]);
      }
      return areas
    },
    getDevices() {
      const deviceInfo = this.$store.getters["devicestore/getDataSet"];
      const devices = [];
      for (let i = 0; i < deviceInfo.devices.length; i++) {
        devices.push(deviceInfo.devices[i]["idGeraet"]);
      }
      return devices
    },
    async getData() {
      const temp = await apiPost("ComponentView/viewDeviceAlarmState", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
        geraete: this.getDevices(),
        MonitoringName: this.MonitoringName
      });
      this.filteredData = temp.map((item) => {
        return { ...item };
      });
      this.originData = temp.map((item) => {
        return { ...item };
      });
    },
    async refreshData() {
      const temp = await apiPost("ComponentView/viewDeviceAlarmState", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
        geraete: this.getDevices()
      });
    },
    customHandler: function (e) {
      console.log("customHandler", e);
    },
  },
};
</script>

<style scoped language="scss">
.k-grid {
  font-size: 12px !important;
}
</style>